import React from 'react';
import {Text, View, FlatList} from 'react-native';
import moment from 'moment';

import GrossArea from './GrossArea';
import Locale from './../../Locale';
import Format from './../../Format';
import {Layout, Navbar} from './../../Screen';
import {Form, Heading1, Heading2, YesNoQuestion, Button} from './../../Form';
import HomeScreen from './HomeScreen';
import HengFaChuenChecking from './../HengFaChuenChecking';
import Confirmation from './../components/Confirmation';
import PolicyHolderConfirmation from './../components/PolicyHolderConfirmation';
import SpecialRequestConfirmation
  from './../components/SpecialRequestConfirmation';
import ImportantNotes from './../components/ImportantNotes';
import DisclaimerAndPIC from './../components/DisclaimerAndPIC';
import DirectMarketing from './../components/DirectMarketing';
import CommissionsDisclosures from './../components/CommissionsDisclosures';
import Payment from './../components/Payment';

export default class HomeScreen4 extends HomeScreen {
  constructor(props) {
    super(props);

    this.readPlanBroker().then((planBroker) => this.setState({planBroker}));
  }

  render() {
    const {
      insuranceProduct: {agent, policy, policyHolder, insuredHome, payment},
      messages,
    } = this.state;
    const {formatName, formatDate, getYesNoLabel} = Format;
    const manualUnderwriting =
      insuredHome.homeType == 'H' ||
      insuredHome.grossArea > 5 ||
      insuredHome.isUnoccupied == 'Y' ||
      insuredHome.isAnyLoss == 'Y' ||
      insuredHome.isOldBuilding == 'Y' ||
      insuredHome.isProposalDeclined == 'Y' ||
      HengFaChuenChecking.check(insuredHome.fullAddress) ||
      !!policy.specialRequest;

    return (
      <Layout alert={this.state.alert}>
        <Navbar
          screen={this}
          title={Locale.text.getInsured}
        />

        {Locale.text.homePackageInsurance}
        {Locale.text.homePackageInsuranceLeftPanel}

        <View style={Layout.container}>
          <Form>
            <Heading1>
              {Locale.text.homePackageInsurance}
            </Heading1>

            <Confirmation
              data={[
                {
                  label: Locale.text.insuranceAdvisorMobile,
                  value: agent.mobile,
                },
                {
                  label: Locale.text.productType,
                  value: this.getIncludeBuildingLabel(),
                },
                {
                  label: Locale.text.effectiveDate,
                  value: formatDate(policy.effectiveDateStart) +
                    ' - ' + formatDate(policy.effectiveDateEnd),
                },
                {
                  label: Locale.text.promotionCodes,
                  value: payment.promotionCode,
                },
                {
                  label: Locale.text.businessEmailMembership,
                  value: policy.businessEmail,
                },
              ]}
            />

            <PolicyHolderConfirmation policyHolder={policyHolder} />

            <Confirmation
              heading={Locale.text.home}
              data={[
                {
                  label: Locale.text.address,
                  value: insuredHome.fullAddress,
                },
                {
                  label: Locale.text.size,
                  value: GrossArea.getDesc(insuredHome.grossArea),
                },
                {
                  label: Locale.text.houseOrApartment,
                  value: this.getHomeTypeLabel(),
                },
                {
                  label: Locale.text.postCopyToMortgagee,
                  value: getYesNoLabel(insuredHome.isPostPolicy),
                },
                {
                  label: Locale.text.nameOfMortgagee,
                  value: insuredHome.mortgageeName,
                },
                {
                  label: Locale.text.addressOfMortgagee,
                  value: insuredHome.mortgageeAddress,
                },
                {
                  label: Locale.text.theHomeIsUnoccupiedForLonger30Days,
                  value: getYesNoLabel(insuredHome.isUnoccupied),
                },
                {
                  label: Locale.text.anyLossDamageLiabilityOrAccident,
                  value: getYesNoLabel(insuredHome.isAnyLoss),
                },
                {
                  label: Locale.text.homePackageTheHomeBuildingIsMoreThan40years,
                  value: getYesNoLabel(insuredHome.isOldBuilding),
                },
                {
                  label: Locale.text.anyInsuranceCompnayDeclined,
                  value: getYesNoLabel(insuredHome.isProposalDeclined),
                },
              ]}
            />

            <SpecialRequestConfirmation policy={policy} />

            <ImportantNotes>
              {Locale.text.thisInsuranceDoesNotCoverTheCostOfGradualDeterioration}
              {Locale.text.theInsuredHomeIsOnlyApplicableToContent}
              {Locale.text.theInsuredHomeISBuiltOfBricksStones}
              {Locale.text.allStructuresOfTheInsured}
              {Locale.text.applicationWillNotBeAccepted}
              {Locale.text.assicurazioniGeneraliSpAReservesTheRightTo}
              {Locale.text.policyholderMustBeHongKongResident}
            </ImportantNotes>

            <DisclaimerAndPIC
              screen={this}
              product={this.getPlanCodeLabel()}
              planBroker={this.state.planBroker}
              value={policy.disclaimerAndPIC}
              onChange={(disclaimerAndPIC) =>
                this.updatePolicy({disclaimerAndPIC})}
              message={messages && messages.disclaimerAndPIC}
            />

            <DirectMarketing
              screen={this}
              value={policy.allowPrivacyPromote}
              onChange={(allowPrivacyPromote) =>
                this.updatePolicy({
                  allowPrivacyPromote,
                  allowPrivacyPromote3P: allowPrivacyPromote,
                })}
              message={messages && messages.allowPrivacyPromote}
            />

            <CommissionsDisclosures
              agent={this.state.agent}
              broker={this.state.broker}
              promotionCode={payment.promotionCode}
              value={policy.commissionsDisclosures}
              onChange={(commissionsDisclosures) =>
                this.updatePolicy({commissionsDisclosures})}
              message={messages.commissionsDisclosures}
            />

            <Payment
              manualUnderwriting={manualUnderwriting}
              broker={this.state.broker}
              payment={payment}
              onChange={(ecash) => this.updatePayment({ecash})}
              premium={this.getParam('premium')}
              levy={this.getParam('levy')}
            />

            <Button
              disabled={this.state.waiting}
              onPress={() => this.confirm()}
            >
              {Locale.text.submit}
            </Button>
          </Form>
        </View>
      </Layout>
    );
  }
}
